<div id="finder" class="tback">
    <div class="container activity-wrapper">
        <mat-form-field class="searchbox">
            <input
                type="text"
                class="searchboxinput"
                [placeholder]="
                    'pages.company-finder.search-businesses' | translate
                "
                autocomplete="off"
                [(ngModel)]="searchData"
                matInput
            />
        </mat-form-field>

        <div class="tenants">
            <div
                *ngFor="
                    let tenant of tenantsOnline | filterdata: searchData;
                    let i = index
                "
                (click)="chooseTenant(tenant)"
                class="tenants infobox"
            >
                <div class="leftinfo">
                    <img
                        class="tenantimg"
                        [src]="
                            tenant.imageUrl
                                ? tenant.imageUrl
                                : '/images/in2logo_inverted_gray.png'
                        "
                        alt="img"
                    />

                    <div class="infotitle">
                        <div class="eventtitle">{{ tenant.name }}</div>
                        <!-- <div class="infotitlecompany">
                            {{ tenant.location ? tenant.location : "No Location" }}
                        </div> -->
                    </div>
                </div>

                <div class="boxcontents">
                    <div class="blockinfo date">
                        <span class="title"></span>
                        <span class="data date">{{ tenant.overview }}</span>
                    </div>
                    <div class="blockinfo trainer">
                        <span class="title"></span>
                        <span class="data trainer colored">
                            {{
                                (tenant.location ? tenant.location : '')
                                    | titlecase
                            }}{{
                                (tenant.country ? ', ' + tenant.country : '')
                                    | titlecase
                            }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
